import { React } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { ContainerCor } from "./style";
import { HiOutlineColorSwatch } from "react-icons/hi";

import PageContainer from "../../components/PageContainer";
import PageHeaderContainer from "../../components/PageHeaderContainer";
import PageContentContainer from "../../components/PageContentContainer";
import { ContainerWithSidebar } from "../../components/ContainerWithSidebar";

function Cores({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
  logOut,
}) {
  return (
    <ContainerWithSidebar
      increaseFontSize={increaseFontSize}
      decreaseFontSize={decreaseFontSize}
      HandledarkMode={HandledarkMode}
      isDarkMode={isDarkMode}
      logOut={logOut}
    >
      <PageContainer>
        <PageHeaderContainer
          title="Paleta de cores"
          icon={<HiOutlineColorSwatch />}
        />
        <PageContentContainer>
          <ContainerCor>
            <Row>
              <Col>
                <h2>Paleta de cores</h2>
                <hr />
              </Col>
            </Row>
            <Row className="area-cores">
              <Col style={{ backgroundColor: "#FFF", color: "#000" }}>#FFF</Col>
              <Col style={{ backgroundColor: "#F2F2F2", color: "#000" }}>
                #F2F2F2
              </Col>
              <Col style={{ backgroundColor: "#D9D9D9", color: "#000" }}>
                #D9D9D9
              </Col>
              <Col style={{ backgroundColor: "#01A998", color: "#FFF" }}>
                #01A998
              </Col>
              <Col style={{ backgroundColor: "#03A688", color: "#FFF" }}>
                #03A688
              </Col>
              <Col style={{ backgroundColor: "#013d32", color: "#FFF" }}>
                #013d32
              </Col>
              <Col style={{ backgroundColor: "#585859", color: "#FFF" }}>
                #585859
              </Col>
              <Col style={{ backgroundColor: "#0D0D0D", color: "#FFF" }}>
                #0D0D0D
              </Col>
            </Row>
          </ContainerCor>
        </PageContentContainer>
      </PageContainer>
    </ContainerWithSidebar>
  );
}

export default Cores;
